import { extractCssStyle } from '../../utilities';

export interface PaddingStylingProps {
  padding?: string;
  paddingBottom?: string;
  paddingTop?: string;
  paddingLeft?: string;
  paddingRight?: string;
}

export const PaddingStyling = (props: PaddingStylingProps) => extractCssStyle(props);
